/**
 * Authentication event utilities
 * 
 * Provides functions to dispatch custom events when authentication state changes.
 * This helps keep components in sync when users log in or out.
 */

/**
 * Dispatches a custom event when user successfully logs in
 */
export const dispatchLoginEvent = () => {
  window.dispatchEvent(new Event('userLoggedIn'));
};

/**
 * Dispatches a custom event when user logs out
 */
export const dispatchLogoutEvent = () => {
  window.dispatchEvent(new Event('userLoggedOut'));
};

/**
 * Adds listeners for authentication events
 * @param {Function} callback - Function to call when auth state changes
 * @returns {Function} Cleanup function to remove listeners
 */
export const addAuthEventListeners = (callback) => {
  const handleAuthChange = () => {
    callback();
  };

  // Listen for storage changes (when token is added/removed)
  window.addEventListener('storage', handleAuthChange);
  window.addEventListener('userLoggedIn', handleAuthChange);
  window.addEventListener('userLoggedOut', handleAuthChange);

  // Return cleanup function
  return () => {
    window.removeEventListener('storage', handleAuthChange);
    window.removeEventListener('userLoggedIn', handleAuthChange);
    window.removeEventListener('userLoggedOut', handleAuthChange);
  };
};
